import React, {useState} from 'react';
import {useAuthState} from "react-firebase-hooks/auth";
import BcLogo from "components/BcLogo";
import {Button, MegaMenu, Navbar} from "flowbite-react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser} from "@fortawesome/free-solid-svg-icons";
import {getAuth, signOut} from "firebase/auth";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import {useLocation, useNavigate} from "react-router-dom";
import clsx from "clsx";
import {assertNoError} from "helpers/asserts";
import {isMobileBreakpoint} from "hooks/tailwind/breakpoint";

export type HeaderProps = {
  hideSignIn?: boolean;
  saveFormCallback: (() => Promise<boolean>) | null;
}


const Header = ({saveFormCallback, hideSignIn}: HeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();
  const [user, loadingUser, errorUser] = useAuthState(auth);
  const isSmallBreakpoint = isMobileBreakpoint();
  const [signingOut, setSigningOut] = useState(false);

  function saveBeforeNavigate(to: string) {
    if (saveFormCallback !== null) {
      saveFormCallback().then(() => {
      });
    }
    navigate(to);
  }

  function login() {
    window.localStorage.removeItem("emailForSignIn");
    saveBeforeNavigate("/login");
  }

  function logout() {
    const auth = getAuth();

    setSigningOut(true);
    signOut(auth).then(() => {
      saveBeforeNavigate("/");
      setSigningOut(false)
    });
  }

  if (loadingUser) {
    return <div className={"w-full h-20"}>&nbsp;</div>;
  }

  assertNoError(errorUser);

  const userMenuHasItems = isNullOrUndefined(user) && !(hideSignIn ?? false) || !isNullOrUndefined(user);

  const UserMenu = isSmallBreakpoint ? <>
        <div className={"w-full flex items-center justify-between px-4 py-2 border-neutral-500"}>
          <Navbar.Link
              className={clsx(
                  "text-base font-normal text-neutral-500",
                  location.pathname === "/" && "text-bc-blue"
              )}
              href=""
              onClick={
                () => saveBeforeNavigate("/")
              }
          >Dashboard</Navbar.Link>
          <div>
            <FontAwesomeIcon
                icon={faUser}
                className={clsx(
                    "w-4 mr-2",
                    !isNullOrUndefined(user) ? "text-bc-blue" : "text-neutral-500"
                )}
            />
            <span className={"text-base font-normal text-neutral-500"}>{user?.email}</span>
          </div>
        </div>
        {userMenuHasItems && <div className="flex justify-end">
          {isNullOrUndefined(user) && !(hideSignIn ?? false) &&
              <Button
                  color={"transparent"}
                  onClick={() => login()}
                  className=""
              >Sign in</Button>
          }
          {!isNullOrUndefined(user) &&
              <Button color={"transparent"} onClick={() => logout()} className="">
                  Sign out
              </Button>
          }
        </div>}
      </>
      : <>
        <Navbar.Link
            className={clsx(
                "text-base font-normal text-neutral-500",
                location.pathname === "/" && "text-bc-blue"
            )}
            href=""
            onClick={
              () => saveBeforeNavigate("/")
            }
        >Dashboard</Navbar.Link>
        {!userMenuHasItems && <div>
            <FontAwesomeIcon
                icon={faUser}
                className={clsx(
                    "w-4 mr-2",
                    !isNullOrUndefined(user) ? "text-bc-blue" : "text-neutral-500"
                )}
            />
        </div>}
        {userMenuHasItems && <MegaMenu.Dropdown
            toggle={<>
              <FontAwesomeIcon
                  icon={faUser}
                  className={clsx(
                      "w-4 mr-2",
                      !isNullOrUndefined(user) ? "text-bc-blue" : "text-neutral-500"
                  )}
              />
              <span className={"text-base font-normal text-neutral-500"}>{user?.email}</span>
            </>}>
          <ul className="flew flex-col">
            <div className="">
              {isNullOrUndefined(user) && !(hideSignIn ?? false) && <li className={"mx-12 my-3"}>
                  <Button
                      color={"transparent"}
                      onClick={() => login()}
                      className="mx-auto"
                  >Sign in</Button>
              </li>}
              {!isNullOrUndefined(user) && <li>
                  <Button color={"transparent"} onClick={() => logout()} className="mx-auto">
                      Sign out
                  </Button>
              </li>}
            </div>
          </ul>
        </MegaMenu.Dropdown>}
      </>;

  return (<>
        <div className="mx-auto">
          <MegaMenu>
            <div className="w-full flex max-w-screen-xl flex-wrap items-center justify-between md:space-x-8">
              <Navbar.Brand className={"grow"} href=""
                            onClick={() => saveBeforeNavigate("/#")}>
                <BcLogo/>
              </Navbar.Brand>
              <Navbar.Toggle/>
              <Navbar.Collapse>
                {!signingOut ? UserMenu : null}
              </Navbar.Collapse>
            </div>
          </MegaMenu>
        </div>
        <hr className="h-1 bg-neutral-50 border-0"/>
      </>
  );
}

export default Header;
